import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DailyRegister } from 'app/models/daily-register.model';
import { ProcessedEntityPayment } from 'app/models/processed-entity-payment.model';
import { MRMValidators } from '@mrm/core';
import { ProcessedEntityExtras } from '../processed-entity-extras.model';

export class ProcessedEntityExtension {
  latestDailyRegister: DailyRegister;
  newPayment: ProcessedEntityPayment;
  processedEntityExtras: ProcessedEntityExtras;
  /**
  * Override the default validation controls to set
  * @param form
  */
  static overrideDefaultForm(form: FormGroup) {
    form.addControl('treatedAsType', new FormControl({ value: null }));
    form.get('processedEntityNumber').setValidators([Validators.required, Validators.maxLength(10), MRMValidators.localNumber]);
    form.get('processedEntityName').setValidators([Validators.required, Validators.maxLength(1000)]);
    form.get('city').setValidators([Validators.required, Validators.maxLength(50)]);
    form.get('provinceDBID').setValidators([Validators.required]);
    form.get('pctProvinceGroupingDBID').setValidators([Validators.required]);
  }
}
